import { render } from "./beneficiary_id_order_by_power_for_management_chart.vue?vue&type=template&id=debccf1c&scoped=true"
import script from "./beneficiary_id_order_by_power_for_management_chart.vue?vue&type=script&lang=js"
export * from "./beneficiary_id_order_by_power_for_management_chart.vue?vue&type=script&lang=js"

import "./beneficiary_id_order_by_power_for_management_chart.vue?vue&type=style&index=0&id=debccf1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-debccf1c"]])

export default __exports__